import React from 'react'

import { HiOutlinePaperAirplane } from 'react-icons/hi2'

import Button from '@/components/common/Button'

interface ApplyFiltersButtonProps {
  onClick: () => void
}

const ApplyFiltersButton: React.FC<ApplyFiltersButtonProps> = ({ onClick }) => {
  return (
    <Button onClick={onClick} type="button" className="h-7 px-[6px] gap-x-1">
      <HiOutlinePaperAirplane className="w-4 h-4" />
      <span className="text-sm font-medium">Apply Filters</span>
    </Button>
  )
}

export default ApplyFiltersButton
